// extracted by mini-css-extract-plugin
export var cartContainer = "_on-4";
export var gray = "_on-1";
export var itemContainer = "_on-2";
export var itemDetails = "_on-3";
export var strong = "_on-0";